import { useQuery } from "react-query";

import { fetchDeploymentTags } from "@api";
import { useOrg } from "@hooks/useOrg";

/*
 * Returns query result with tags from current selected org
 */
export const useDeploymentTags = () => {
  const org = useOrg();

  return useQuery(
    ["deployment_tags", { org }],
    () =>
      fetchDeploymentTags(org?.id!).then((response) => {
        return response.repository_tags;
      }),
    {
      enabled: !!org,
    }
  );
};
